// Chimes sintéticos (Web Audio API) — sem assets externos, sem deps novas.
//
// Por que sintetizado em vez de MP3:
//   - Zero bytes no bundle (vs ~50KB por chime × 2 = 100KB)
//   - Sem licença pra tracking (Mixkit CC0 seria ok, mas evita dependência
//     externa e possível mudança de URL no futuro)
//   - Latência zero (não espera download)
//   - Fácil reutilizar AudioContext com o pré-warm mic (futuro)
//
// Timbre: duas sinusóides com envelope exponencial rápido. Estilo
// "ting" curto (ativar) e "tap" breve (confirmar), volume moderado (0.18).

let _ctxSingleton = null;

function getCtx() {
  if (_ctxSingleton && _ctxSingleton.state !== "closed") return _ctxSingleton;
  const AudioCtx = typeof window !== "undefined" && (window.AudioContext || window.webkitAudioContext);
  if (!AudioCtx) return null;
  _ctxSingleton = new AudioCtx();
  return _ctxSingleton;
}

/**
 * Toca dois semitons rápidos em sequência.
 * @param {Array<[freq, delaySec, durSec]>} notes
 * @param {number} peakGain — pico do envelope (0..1). Default 0.18 (sutil).
 */
function playNotes(notes, peakGain = 0.18) {
  const ctx = getCtx();
  if (!ctx) return;
  // Safari/iOS exige resume após user gesture.
  if (ctx.state === "suspended") { ctx.resume().catch(() => {}); }

  const now = ctx.currentTime;
  notes.forEach(([freq, delay, dur]) => {
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = "sine";
    osc.frequency.value = freq;
    // Envelope: attack instant (1ms), decay exponencial pra ~0 em `dur` segundos.
    gain.gain.setValueAtTime(0, now + delay);
    gain.gain.linearRampToValueAtTime(peakGain, now + delay + 0.005);
    gain.gain.exponentialRampToValueAtTime(0.0001, now + delay + dur);
    osc.connect(gain).connect(ctx.destination);
    osc.start(now + delay);
    osc.stop(now + delay + dur + 0.02);
  });
}

/**
 * Som "ti-ding" — toca ao ativar o mic (antes da saudação).
 * Dois tons ascendentes, ~280ms total.
 */
export function playListenChime() {
  // C5 (523) → E5 (659). Intervalo de terça maior, timbre acolhedor.
  playNotes([
    [523.25, 0.00, 0.12],
    [659.25, 0.10, 0.16],
  ]);
}

/**
 * Som "tap" — toca quando VAD detecta fim da fala (antes de mandar).
 * Um tom curto, ~150ms.
 */
export function playReceivedChime() {
  // G5 (784) tom único, bem curto. Sensação de "check recebido".
  playNotes([
    [783.99, 0.00, 0.10],
  ], 0.14);
}

/**
 * Garante que o AudioContext está resumed. Chame em user gesture pra
 * destravar iOS/Safari antes de tentar tocar os chimes. Idempotente.
 */
export function ensureChimesReady() {
  const ctx = getCtx();
  if (ctx && ctx.state === "suspended") {
    return ctx.resume().catch(() => {});
  }
  return Promise.resolve();
}
